<!-- slider main wrapper -->
<div
	class="slider-container"
	[ngClass]="{ 'slider-collapsed': !isActive }"
	aria-labelledby="title"
	aria-live="assertive"
	aria-modal="true">
	<!-- overlay -->
	<div
		class="slider-overlay"
		[ngStyle]="{
			transition: 'background-color ' + duration + 's, visibility ' + duration + 's'
		}"
		[ngClass]="{ 'slider-overlay-collapsed': !isActive }"
		(click)="close()"></div>

	<!-- slider content-->
	<div
		#sliderContent
		class="slider-content d-flex"
		[ngClass]="{ 'slider-bg-white': setSliderBgColor }"
		[ngStyle]="sliderStyle"
		eaFocusTrap>
		<!-- slider body -->
		<div aria-live="assertive" class="slider-panel">
			<ng-container *ngTemplateOutlet="slidingPanelTemplate"></ng-container>
		</div>
	</div>
</div>
